import { render, staticRenderFns } from "./Minifield.vue?vue&type=template&id=0900f5a2&scoped=true&"
import script from "./Minifield.vue?vue&type=script&lang=js&"
export * from "./Minifield.vue?vue&type=script&lang=js&"
import style0 from "./Minifield.vue?vue&type=style&index=0&id=0900f5a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0900f5a2",
  null
  
)

export default component.exports